/**
 * 客户端管理 Saga集合
 */
import messageMove from './messageMove/model';
import baseset_slide from './baseset/slide/model';
import baseset_mood from './baseset/mood/model';
import help_strategy from './help/strategy/model';
import help_instruction from './help/instruction/model';

export default [
    ...Object.values(messageMove.sagas), // 消息推送
    ...Object.values(baseset_slide.sagas), // 幻灯片管理
    ...Object.values(baseset_mood.sagas), // 心情管理
    ...Object.values(help_strategy.sagas), // 攻略管理
    ...Object.values(help_instruction.sagas), // 初始说明
];
